module.exports = __webpack_public_path__ + "static/media/img68.571c1948.png";